import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export type Project = {
	id: string;
	key: string;
	projectTypeKey: 'customer_service';
	permissions: {
		canEdit: boolean;
	};
};

const getData = async () => {
	try {
		const data = await fetchJson<{ values: Project[] }>(
			'/rest/api/2/project/search?maxResults=100&typeKey=customer_service&expand=permissions',
		);

		const projectWhereAdmin = data?.values?.find((project) => project.permissions.canEdit);
		const projectWhereUser = data?.values?.find((project) => !project.permissions.canEdit);
		return projectWhereAdmin || projectWhereUser || null;
	} catch (error) {
		fireErrorAnalytics({
			meta: {
				id: 'l1CustomersProjectProvider',
				packageName: 'jiraRouterResourcesCustomerServiceL1CustomersProjectProvider',
				teamName: 'Boysenberry',
			},
			error: error instanceof Error ? error : undefined,
		});

		throw error;
	}
};

export default getData;
